import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  formatNumber,
  truncateToTwoDecimals,
} from "../../../../../../utility/helper";
import { FaArrowLeft } from "react-icons/fa";

const DetailsTable = ({
  viewInnerDetails,
  onBack,
  onSelectDetail,
  groupsData,
}) => {
  const assetNameTemplate = (rowData) => {
    return (
      <div className="">
          {formatNumber(rowData.asset_name ? rowData.asset_name : "-")}
      </div>
    );
  };

  const sectorTemplate = (rowData) => {
    return <div>{rowData.sector ? rowData.sector : "-"}</div>;
  };

  const structureTemplate = (rowData) => {
    const matched = groupsData?.find((item) => item.id === rowData.group);
    return <div>{matched ? matched.name : rowData.group || "-"}</div>;
  };

  const performanceTemplate = (rowData) => {
    return (
      <div className="">
        {formatNumber(truncateToTwoDecimals(rowData.performance_value ? rowData.performance_value : "0"))}
      </div>
    );
  };

  const valueTemplate = (rowData) => {
    return (
      <div className="">
        {formatNumber(truncateToTwoDecimals(rowData.current_value ? rowData.current_value : "0"))}
      </div>
    );
  };

  return (
    <div>
      <button onClick={onBack}>
        <FaArrowLeft fontSize={24} className="text-info dark:text-white" />
      </button>
      <div className="grid grid-cols-2 mb-12 pl-12 max-w-xl font-bold dark:text-white text-lightPrimary">
        <div>Selected Wealth</div>
        <div>
          CHF {formatNumber(truncateToTwoDecimals(viewInnerDetails?.wealth))}
        </div>
      </div>
      <DataTable
        value={viewInnerDetails?.table_data}
        className="transaction mt-3"
        sortMode="multiple"
        totalRecords={viewInnerDetails?.data?.length}
      >
        <Column
          field="asset_name"
          header="Asset name"
          body={assetNameTemplate}
          style={{ width: "15%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="sector"
          header="Sector"
          body={sectorTemplate}
          style={{ width: "15%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="group"
          header="Structure"
          body={structureTemplate}
          style={{ width: "15%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="performance_value"
          header="Performance in CHF"
          style={{ width: "17%" }}
          align={"right"}
          body={performanceTemplate}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="current_value"
          header="Value in CHF"
          align={"right"}
          style={{ width: "18%" }}
          body={valueTemplate}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        {/* <Column
          field="FP"
          header="FP / Debt"
          style={{ width: "20%" }}
          align={"right"}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        /> */}
      </DataTable>
    </div>
  );
};

export default DetailsTable;